export default __webpack_public_path__ + "static/media/Website.c7db6475.png";